module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('CaddyPreview', {
    attrs: {
      "caddy": _vm.data
    }
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "caddy"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.ladderWidth),
      expression: "data.ladderWidth",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "ladderWidth",
      "name": "ladderWidth"
    },
    domProps: {
      "value": (_vm.data.ladderWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.ladderWidth = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.ladderHeight),
      expression: "data.ladderHeight",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "ladderHeight",
      "name": "ladderHeight"
    },
    domProps: {
      "value": (_vm.data.ladderHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.ladderHeight = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.topPawl),
      expression: "topPawl",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "topPawl",
      "name": "topPawl"
    },
    domProps: {
      "value": (_vm.topPawl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topPawl = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bottomPawl),
      expression: "bottomPawl",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "bottomPawl",
      "name": "bottomPawl"
    },
    domProps: {
      "value": (_vm.bottomPawl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bottomPawl = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.pawlInterval),
      expression: "data.pawlInterval",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "pawlInterval",
      "name": "pawlInterval"
    },
    domProps: {
      "value": (_vm.data.pawlInterval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.pawlInterval = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.intermediateLadderCount),
      expression: "data.intermediateLadderCount",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "intermediateLadderCount",
      "name": "intermediateLadderCount"
    },
    domProps: {
      "value": (_vm.data.intermediateLadderCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.intermediateLadderCount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('RoundedButton', {
    on: {
      "click": function($event) {
        _vm.data.clipDevices = [{
          x: 0,
          y: 0
        }];
      }
    }
  }, [_vm._v("Reset anchors")]), _vm._v(" "), _c('RoundedButton', {
    on: {
      "click": function($event) {
        _vm.data.clipDevices.push({
          x: 0,
          y: 0
        });
      }
    }
  }, [_vm._v("Add an anchor")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Ladders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    attrs: {
      "for": "ladderWidth"
    }
  }, [_vm._v("Width :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    attrs: {
      "for": "ladderHeight"
    }
  }, [_vm._v("Height :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    attrs: {
      "for": "topPawl"
    }
  }, [_vm._v("Top pitch :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    attrs: {
      "for": "bottomPawl"
    }
  }, [_vm._v("Bottom pitch :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    attrs: {
      "for": "pawlInterval"
    }
  }, [_vm._v("Pitch interval :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    attrs: {
      "for": "intermediateLadderCount"
    }
  }, [_vm._v("Intermediate ladder count :")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19593ceb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/caddy-form.vue
// module id = 3044
// module chunks = 0